<template>
  <div class="home">
    <div class="head">
      <p class="head-text">
        您仅需完成以下2个步骤，即可在个人主页商品橱窗、短视频、直播中分享推广精选联盟商品，开启带货之路！
      </p>
    </div>
    <div class="main">
      <section class="step">
        <div
          class="step-row"
          :class="{
            active: !form.isAuthentication || !form.isBond,
            complete: form.isAuthentication && form.isBond,
          }"
        >
          <div class="title">
            <span>STEP 01 带货权限申请</span>
            <span class="status">{{
              form.isAuthentication && form.isBond ? "已完成" : "未完成"
            }}</span>
          </div>
          <p class="step-info border">
            申请成功后，可在商品橱窗/短视频/直播间添加商品，需完成实名认证及缴纳作者保证金
          </p>
        </div>
        <div
          class="step-row"
          :class="{
            active:
              form.isAuthentication &&
              form.isBond &&
              !form.haveWx &&
              !form.haveJh,
            finish: form.haveWx && form.haveJh,
          }"
          style="margin-top: 5px"
        >
          <div class="title">
            <span>STEP 02 开通收款账户</span>
            <span class="status">{{
              form.haveJh && form.haveWx ? "已开通" : "未开通"
            }}</span>
          </div>
          <p class="step-info">
            开通后可提取您的佣金收入，并在完整拥有商品橱窗/短视频/直播间的带货权限
          </p>
          <p class="tips">所需材料：身份证或个体/企业营业执照等</p>
        </div>
      </section>
      <section class="advantage">
        <p class="title">成为带货主播为时不晚</p>
        <div class="row">
          <div>
            <el-image
              :src="require('@/assets/images/simulation/icon1.png')"
              fit="cover"
            ></el-image>
            <span class="title">流量不愁</span>
          </div>
          <p class="ad-text">面向超6亿日活用户，流量机会等你挖掘</p>
        </div>
        <div class="row">
          <div>
            <el-image
              :src="require('@/assets/images/simulation/icon2.png')"
              fit="cover"
            ></el-image>
            <span class="title">货源无忧</span>
          </div>
          <p class="ad-text">
            提供品牌旗舰店/专卖店、档口/柜台、产业带/工厂等优质货源，海量货品让你无忧
          </p>
        </div>
      </section>

      <section class="case">
        <p class="title">成功案例</p>
        <div class="wrapper">
          <div class="slider">
            <div class="case-item" v-for="(item, idx) in caseList" :key="idx">
              <el-image :src="item.avatar" fit="cover"></el-image>
              <div class="info">
                <p class="name">{{ item.name }}</p>
                <div class="statistics">
                  <div class="fans">
                    <span class="count">{{ item.fans }}</span>
                    <p class="count-text">粉丝</p>
                  </div>
                  <div class="sales">
                    <span class="count">{{ item.sales }}</span>
                    <p class="count-text">爆款销量</p>
                  </div>
                </div>
                <p class="marks">“</p>
                <p class="introduction">{{ item.introduction }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="bottom" v-if="!form.haveJh || !form.haveWx">
      <div class="btn" @click="onClick">{{ btnText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: Object,
  },
  data() {
    return {
      caseList: [
        {
          avatar: require("@/assets/images/simulation/icon_yz.png"),
          name: "大狼狗郑建鹏&言真夫妇",
          fans: "5177.5w",
          sales: "70w+",
          introduction:
            "一对夫妻从抖音短视频零起步，在粉丝突破1000万之时开启直播电商转型之路。以“品质直播间，服务千家万户”为理念，用短视频给大家带来快乐，用直播给粉丝带来实惠和服务。",
        },
        {
          avatar: require("@/assets/images/simulation/icon_qh.png"),
          name: "千惠",
          fans: "312w",
          sales: "4w+",
          introduction:
            "中戏毕业音乐剧演员，抖音创业的二胎妈妈，通过短视频收获大量粉丝，在直播中分享自己的爱用好物，创造多个品牌的抖音销售记录，雅萌美容仪销量4w+。",
        },
        {
          avatar: require("@/assets/images/simulation/icon_dxy.png"),
          name: "董新尧",
          fans: "1014w",
          sales: "15w+",
          introduction:
            "单场直播涨粉30万，直播人气稳定万人在线，视频达人成功转型带货达人，快速提高了粉丝活跃度和商业价值。",
        },
      ],
    };
  },
  computed: {
    btnText() {
      if (!this.form.isAuthentication || !this.form.isBond)
        return "带货权限申请";
      else if (!this.form.haveJh || !this.form.haveWx) return "开通收款账户";
    },
  },
  methods: {
    onClick() {
      if (this.btnText == "带货权限申请") {
        this.$router.push("/simulation/douyinchuchuang/step1");
      } else if (this.btnText == "开通收款账户") {
        this.$router.push("/simulation/douyinchuchuang/step2");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  padding-bottom: 60px;
  .head {
    padding: 10px 10px 100px;
    color: #c0c4cc;
    background-color: #203161;
    border-bottom-left-radius: 50%;
    border-bottom-right-radius: 50%;
    .head-text {
      line-height: 1.5;
    }
  }
  .main {
    margin-top: -85px;
    padding: 0 10px;
    section {
      margin-bottom: 8px;
      padding: 20px 15px;
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0 8px 12px #ebedf0;
      &.step {
        .step-row {
          // overflow: hidden;
          .title {
            position: relative;
            margin-bottom: 5px;
            padding-left: 20px;
            &::after {
              content: "";
              position: absolute;
              top: 7px;
              left: -3px;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background-color: #909399;
            }
            &::before {
              content: "";
              position: absolute;
              top: 3px;
              left: -7px;
              width: 16px;
              height: 16px;
              border-radius: 50%;
              background-color: #dcdfe6;
            }
            .status {
              float: right;
              // font-size: 12px;
              color: #909399;
            }
          }
          .step-info {
            padding: 5px 0 20px 20px;
            color: #909399;
            &.border {
              border-left: dashed 1px #909399;
            }
          }
          .tips {
            margin-top: -15px;
            margin-left: 20px;
            padding: 5px 10px;
            background-color: #f2f6fc;
            font-size: 12px;
            color: #909399;
          }
          &.finish,
          &.complete,
          &.active {
            .title {
              &::after {
                background-color: #e21e48;
              }
              &::before {
                background-color: #fccdd7;
              }
            }
            &.finish,
            &.active {
              .status {
                color: #e21e48;
              }
            }
            &.complete {
              .border {
                border-left: dashed 1px #e21e48;
              }
            }
          }
        }
      }
      .title {
        font-size: 14px;
        font-weight: bold;
      }
      .row {
        margin-top: 20px;
        .title {
          margin-left: 5px;
          vertical-align: top;
        }
        .ad-text {
          margin-top: 10px;
          color: #909399;
        }
      }
      .wrapper {
        margin-top: 10px;
        width: 100%;
        overflow-x: auto;

        .slider {
          width: 650px;
          overflow: hidden;
          .case-item {
            float: left;
            width: 210px;
            text-align: center;
            &:nth-child(2) {
              margin: 0 10px;
            }
            .info {
              margin-top: -31px;
              padding: 31px 15px 0;
              background-image: linear-gradient(#fff9f5, #fff);
              .name {
                margin-top: 5px;
                font-weight: bold;
              }
              .statistics {
                margin-top: 10px;
                margin-bottom: 5px;
                overflow: hidden;
                .fans {
                  float: left;
                  padding: 0 15px;
                }
                .sales {
                  float: right;
                  padding: 0 15px;
                }
                .count {
                  color: #ec1d4a;
                  font-weight: bold;
                  font-size: 16px;
                }
                .count-text {
                  font-size: 12px;
                  color: #909399;
                }
              }
              .marks {
                text-align: left;
                font-size: 50px;
                line-height: 1;
                color: #fcef98;
              }
              .introduction {
                margin-top: -28px;
                text-align: justify;
                font-size: 12px;
                line-height: 1.8;
                color: #909399;
                word-break: break-all;
              }
            }
          }
        }
      }
    }
  }
  .bottom {
    position: fixed;
    bottom: 0;
    padding: 10px;
    width: 100%;
    background-color: #f2f6fc;
    box-shadow: 0 -8px 12px #f2f6fc;
    .btn {
      padding: 10px 0;
      text-align: center;
      color: #fff;
      background-color: #e21e48;
      border-radius: 3px;
      cursor: pointer;
    }
  }
}
</style>